import productsService from './productsService'

export default productsService



// WEBPACK FOOTER //
// ../src/services/productsService/index.js